import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule,  } from '@angular/material/input';
import { KeyVal } from '@app/models/common';
import { MatSelectModule} from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'so-select',
  templateUrl: './so-select.component.html',
  styleUrls: ['./so-select.component.css'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [ 
    CommonModule,
    MatIconModule,
    MatFormFieldModule,
    MatInputModule,    
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule
  ]
})
export class SoSelectComponent {
  @Input() formCtrl: FormControl;
  @Input() placeHolder = "Please enter text.";
  @Input() disableClearBtn = false;
  @Input() errormessage = "Entry is invalid."
  @Input() label = "Label Not set."
  @Input() labelClass = ""
  @Input() options:  KeyVal[] = [];
  @Input() toolTip = "";
 
  


  clearControl() {
    this.formCtrl.setValue(""); 
  }
 
}
